import { render, staticRenderFns } from "./OrdersReceive.vue?vue&type=template&id=d9026362"
import script from "./OrdersReceive.vue?vue&type=script&lang=js"
export * from "./OrdersReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports